import { ErrorsPage } from '@/components/shared/errors-page';
import loadIntlMessages from '@/logic/helpers/loadIntlMessages';
import { Box } from '@mui/material';
import { GetStaticProps, NextPage } from 'next';

const NotfoundIcon = '/icons/shared/not-found-no-data.svg';

const SomeThingWentWrong: NextPage = () => {
  return (
    <Box>
      <ErrorsPage
        title='page_not_found.title'
        description='page_not_found.description'
        pageImage={NotfoundIcon}
      />
    </Box>
  );
};

export const getStaticProps: GetStaticProps = async context => {
  const { locale, defaultLocale } = context;
  return {
    props: { intlMessages: await loadIntlMessages(locale as string, defaultLocale) },
  };
};

export default SomeThingWentWrong;
